import React, { useEffect } from 'react';
import { Routes } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import theme from './theme/theme';
import { useAuthStore } from './stores/authStore';
import PublicRoutes from './routes/PublicRoutes';
import ProtectedRoutes from './routes/ProtectedRoutes';
import CatchAllRoute from './routes/CatchAllRoute';
import './styles/MuiCustomStyles.css';

const App: React.FC = () => {
  const { isAuthenticated, checkSessionExpiration, registerActivity } = useAuthStore();

  // Verificar expiración de sesión al cargar la aplicación
  useEffect(() => {
    checkSessionExpiration();
  }, [checkSessionExpiration]);

  // Reiniciar timeout de sesión cuando hay actividad del usuario
  useEffect(() => {
    if (!isAuthenticated) {
      return;
    }

    const handleUserActivity = () => {
      registerActivity();
    };

    const activityEvents: Array<keyof WindowEventMap> = [
      'mousedown',
      'mousemove',
      'keydown',
      'scroll',
      'touchstart',
      'click',
    ];

    activityEvents.forEach(eventName => {
      window.addEventListener(eventName, handleUserActivity);
    });

    const expirationInterval = setInterval(() => {
      checkSessionExpiration();
    }, 30_000);

    return () => {
      activityEvents.forEach(eventName => {
        window.removeEventListener(eventName, handleUserActivity);
      });
      clearInterval(expirationInterval);
    };
  }, [isAuthenticated, registerActivity, checkSessionExpiration]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Routes>
        {PublicRoutes({ isAuthenticated })}
        {ProtectedRoutes({})}
        {CatchAllRoute({ isAuthenticated })}
      </Routes>
    </ThemeProvider>
  );
};

export default App;
